import { defineMessages } from "react-intl"

export default defineMessages({
  goToHome: {
    defaultMessage: "GO TO HOME",
    id: "src.pages.goToHome",
  },
  notFoundMessage: {
    defaultMessage: "The Page you are looking was not found.",
    id: "src.pages.notFoundMessage",
  },
})
